import { ChangeDetectionStrategy, Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'ap-header',
  templateUrl: './header.component.html',
  host: {
    'class': 'ap-header'
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {

  @Input() menuClass: string;

}
